import styled, { css } from "styled-components";

import { fadeInAnimation } from "app/pages/sales-intelligence/common-components/animations";

import { TABLE_IS_SCROLL_CS } from "../styles";

const staggeredDelays = (groups: number, size: number, stepMs: number) =>
    Array.from(
        { length: groups },
        (_, i) =>
            i > 0 &&
            css`
                &:nth-child(n + ${i * size + 1}) {
                    animation-delay: ${i * stepMs}ms;
                }
            `,
    );

export const StyledTableWrapper = styled.div<{ hasNoData: boolean }>`
    ${({ hasNoData }) =>
        hasNoData &&
        css`
            & .ant-table-wrapper .ant-table-tbody > tr > td {
                border-bottom: none;
            }
        `};

    & .ant-table-wrapper .ant-table-tbody .ant-table-row-highlight .ant-table-cell-fix-left {
        background: transparent;
    }

    & .ant-table-cell.ant-table-selection-column {
        justify-content: center;
    }

    /* ---- VIRTUAL TABLE STYLES ---- */
    .ant-table-tbody-virtual-holder-inner {
        /* scroll container (rc-virtual-list-holder) must have its own layer */
        contain: layout style paint;

        /* scroll container (rc-virtual-list-holder) does the transform: translateY() on scroll */
        will-change: transform;
    }

    .${TABLE_IS_SCROLL_CS} & .ant-table-tbody-virtual-holder-inner {
        pointer-events: none;
    }

    .ant-table-tbody {
        .ant-table-row {
            /* rows are independent formatting contexts -> can skip recalculating siblings on scroll */
            contain: layout style paint;

            /*
                 The virtual table renders ~15 rows on mount. Each row is expensive.
                 The compound cost means bottom rows might paint visibly later than top rows, creating a "flash" at the table bottom.
                 Adding a short animation. Using cubic-bezier(0.4, 0, 0.2, 1) for smoothness.
            */
            animation: ${fadeInAnimation} 250ms cubic-bezier(0.4, 0, 0.2, 1) both;
            ${staggeredDelays(6, 3, 25)}

            div.ant-table-cell {
                display: flex;
                align-items: center;
            }

            div.ant-table-cell[style*="text-align: end"],
            div.ant-table-cell[style*="text-align: right"] {
                justify-content: flex-end;
            }

            .ant-table-cell-content {
                width: 100%;
                min-width: 0;
            }
        }
    }

    .${TABLE_IS_SCROLL_CS} & .ant-table-tbody .ant-table-row {
        animation-duration: 0s;
        animation-delay: 0s;
    }
`;
